var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 48,
    viewBox: "0 0 91 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.04 47.6533C27.7329 47.8611 27.3707 47.9721 27 47.9721C26.6293 47.9721 26.267 47.8611 25.96 47.6533C21.0373 44.3653 0.333313 29.7333 0.333313 15.928C0.333313 -1.88533 21.2666 -4.73867 27 7.26133C32.7333 -4.73867 53.6666 -1.88533 53.6666 15.928C53.6666 29.736 32.9626 44.3653 28.04 47.648V47.6533Z",
    fill: "#DD0808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7067 47.6561C64.3996 47.8638 64.0374 47.9748 63.6667 47.9748C63.2959 47.9748 62.9337 47.8638 62.6267 47.6561C57.704 44.3681 37 29.7361 37 15.9307C37 -1.88259 57.9333 -4.73592 63.6667 7.26408C69.4 -4.73592 90.3333 -1.88259 90.3333 15.9307C90.3333 29.7387 69.6293 44.3681 64.7067 47.6507V47.6561Z",
    fill: "#F95D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleHeart);
export default __webpack_public_path__ + "static/media/double-heart.a9ce36fb3a7ba41f6b6eebf1313fc1ff.svg";
export { ForwardRef as ReactComponent };